import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c1fe4b02"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "CookieBanner"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", null, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("OK")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_btn = _resolveComponent("ui-btn")!

  return (_openBlock(), _createBlock(_Transition, {
    onEnter: _ctx.onEnter,
    onLeave: _ctx.onLeave,
    appear: ""
  }, {
    default: _withCtx(() => [
      (_ctx.$store.state.showCookieBanner)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('cookies.description')), 1),
              _createElementVNode("a", {
                href: "#legals",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.legalPage.open(_ctx.LegalPages.LEGALS)), ["prevent"])),
                target: "_blank"
              }, _toDisplayString(_ctx.$t('cookies.cta')), 1)
            ]),
            _hoisted_2,
            _createVNode(_component_ui_btn, { onClick: _ctx.close }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onEnter", "onLeave"]))
}